<template>
  <div class="h_title m-b-15">
    <ul>
      <li :class="'order_cate_' + index + [active === index ? ' active_bg' : '']" :data-active_bg="index" v-for="(item, index) in list" @click="toggle(index)">
        <a href="javascript:;" :style="{ 'color': active === index ? $store.state.color : '' }" >
          {{item.name}}<span v-if="item.number">({{item.number}})</span>
          <em :style="{ 'background': active === index ? $store.state.color : '' }"></em>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['list', 'active'],
  methods: {
    toggle (index) {
      this.$emit('active', index)
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue